import { FC } from "react"
import { SidebarListItemProps } from "../types"

export const SideBarListItems: FC<SidebarListItemProps> = ({ className, ...props }) => {
    return (
        <ul {...props} className={`${className} space-y-2 group-hover:text-gray-900`} />
    )
}